import { useSelector } from "~/redux/store";
import { FeatureFlagsState } from "~/redux/slice/featureFlags";

/**
 * Returns whether a feature flag is enabled for the current tenant.
 *
 * ─────────────────────────────────────────────────────────────────
 * AI FEATURE GATE RULE (DEV_STANDARDS.md — mandatory):
 *
 *   const isAiUseEnabled = useFeatureFlag("isAiUseEnabled");
 *   if (!isAiUseEnabled) { <render non-AI fallback> }
 *
 * Any component that invokes AI behaviour MUST call this hook first.
 * A non-AI fallback path MUST be implemented in the same component.
 * ─────────────────────────────────────────────────────────────────
 *
 * @param flag - Key from FeatureFlagsState (e.g. "isAiUseEnabled")
 * @returns boolean — true if enabled (safe default if flags not yet loaded)
 */
export function useFeatureFlag(
  flag: keyof Omit<FeatureFlagsState, "loaded">,
): boolean {
  return useSelector(
    (state) => state.persistedReducer.featureFlags[flag] ?? true,
  );
}
